import DefaultLayout from "../../../layouts/DefaultLayout";
import {Table} from "../../tables/BasicTable";
import React, {useContext, useEffect, useState} from "react";
import {useAuth} from "../../../providers/authProvider";
import BoxLayout from "../../../layouts/BoxLayout";
import DefaultButton from "../../buttons/DefaultButton";
import {ApiContext} from "../../contexts/ApiContext";
import {useNavigate} from "react-router-dom";
import NewHomeVisitCategoryModal from "../../modals/NewHomeVisitCategoryModal";
import EditHomeVisitCategoryModal from "../../modals/EditHomeVisitCategoryModal";
import H2Header from "../../headers/h2";
import NewHomeVisitModal from "../../modals/NewHomeVisitModal";
import EditButton from "../../buttons/EditButton";
import DeleteButton from "../../buttons/DeleteButton";
import SelectInput from "../../input/SelectInput";
import { getSenderEmail } from "../../../utils/mailUtils";
import {FaCheck, FaEye, FaClock, FaUsers} from "react-icons/fa";
import { ImCross } from "react-icons/im";
import {generateFinalVisitInfoEmailContent} from "../../mail/HuistbezoekLaatsteInfo";
import {generateInvoiceAndGroteBoekEmailContent} from "../../mail/FactuurEnGroteBoek";

function AdminHomeVisitsPage() {

    const {Url } = useContext(ApiContext)
    const { token } = useAuth();
    const [homeVisits, setHomeVisits] = useState<any[]>([])
    const [homeVisitCategories, setHomeVisitCategories] = useState<any[]>([])
    const [loading, setLoading] = useState(false)
    const [dataAvailable, setDataAvailable] = useState(false)
    const [dataAvailableCategories, setDataAvailableCategories] = useState(false)
    const [openAddHomeVisitCategoryModal, setOpenAddHomeVisitCategoryModal] = useState(false);
    const [openEditHomeVisitCategoryModal, setOpenEditHomeVisitCategoryModal] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState<any>(null);
    const [openAddHomeVisitModal, setOpenAddHomeVisitModal] = useState(false);
    const [authorized, setAuthorized] = useState(false)
    const [selectedTeam, setSelectedTeam] = useState("0");
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const navigate = useNavigate();
    function handleShow (rowDataInput: any){
        navigate("/admin/home-visit-details/" + rowDataInput.ID, { replace: false })
    }
    // Selection state for mass actions
    const [selectedIds, setSelectedIds] = useState<Set<any>>(new Set());
    const [selectedAction, setSelectedAction] = useState("");
    const [selectAll, setSelectAll] = useState(false);
    const [message, setMessage] = useState('');

    const toggleSelectAll = () => {
        if (selectAll) {
            setSelectedIds(new Set());
        } else {
            // Get visible rows from the table
            const tableElement = document.querySelector('table');
            const visibleRows = tableElement?.querySelectorAll('tbody tr:not([style*="display: none"])');
            const visibleIds = Array.from(visibleRows || []).map(row => {
                return parseInt(row.querySelector('td:nth-child(2)')?.textContent || '0');
            }).filter(id => id > 0);

            setSelectedIds(new Set(visibleIds));
        }
        setSelectAll(!selectAll);
    };

    const toggleSelect = (id: any) => {
        setSelectedIds(prev => {
            const next = new Set(prev);
            if (next.has(id)) next.delete(id);
            else next.add(id);
            return next;
        });
    };

    const clearSelection = () => setSelectedIds(new Set());

    const handleDeleteHomeVisitCategory = (id: number) => {
        fetch(Url + 'admin/home-visit-categories/' + id, {
            method: 'DELETE',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
        })
            .then(res => res.json())
            .then(data => {
                setMessage(data.message);
                setRefreshTrigger(prev => prev + 1);
            })
            .catch(err => {
                console.error(err);
                setMessage("Verwijderen mislukt");
            });
    }

    const handleApplyMassAction = async () => {
        if (!selectedAction || selectedIds.size === 0) return;

        // Handle mass email action separately
        if (selectedAction === "sendLaatsteInfo") {
            await handleMassSendLaatsteInfoEmail();
            return;
        }
        
        if (selectedAction === "sendFactuurEnGroteBoek") {
            await handleMassSendFactuurEnGroteBoekEmail();
            return;
        }

        try {
            const response = await fetch(Url + 'admin/home-visits/mass-action', {
                method: 'POST',
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                body: JSON.stringify({ action: selectedAction, ids: Array.from(selectedIds) })
            });

            if (response.ok) {
                console.log("Applying mass action:", selectedAction, "to IDs:", Array.from(selectedIds));

                // Refresh the data
                setLoading(true);
                const refreshResponse = await fetch(Url + 'admin/home-visits', {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': "Bearer " + token,
                    },
                });

                if (refreshResponse.status === 200) {
                    const data = await refreshResponse.json();
                    setHomeVisits(data);
                    setDataAvailable(true);
                }

                setLoading(false);
                clearSelection();
            }
        } catch (error) {
            console.error("Error applying mass action:", error);
            setLoading(false);
        }
    };

    const handleMassSendLaatsteInfoEmail = async () => {
        setMessage(`Bezig met versturen van ${selectedIds.size} email(s)...`);
        let successCount = 0;
        let failCount = 0;

        try {
            // Get selected home visits
            const selectedVisits = homeVisits.filter(visit => selectedIds.has(visit.ID));

            for (const visit of selectedVisits) {
                try {
                    // Generate email content for this visit
                    const emailContent = generateFinalVisitInfoEmailContent({
                        naam: visit.FirstName,
                        typeBezoek: visit.HomeVisitCategoryName,
                        datum: visit.Date,
                        starttijd: visit.StartTime,
                        adres: visit.Address,
                        plaats: visit.City,
                        factuurBetaald: visit.Payed,
                        groteBoekIngevuld: visit.NumberOfChildren > 0
                    }) as any;

                    // Send email
                    const response = await fetch(Url + 'admin/send-mail', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${token}`
                        },
                        body: JSON.stringify({
                            sender: getSenderEmail(),
                            recipient: visit.Email,
                            cc: getSenderEmail(),
                            subject: `Huisbezoek fam. ${visit.LastName} - laatste informatie`,
                            htmlBody: emailContent.html
                        })
                    });

                    if (response.ok) {
                        successCount++;
                    } else {
                        failCount++;
                        console.error(`Failed to send email to ${visit.Email}`);
                    }
                } catch (error) {
                    failCount++;
                    console.error(`Error sending email to ${visit.Email}:`, error);
                }
            }

            // Show result message
            if (failCount === 0) {
                setMessage(`✓ Alle ${successCount} email(s) succesvol verzonden!`);
            } else {
                setMessage(`⚠ ${successCount} email(s) verzonden, ${failCount} mislukt`);
            }

            // Clear message after 5 seconds
            setTimeout(() => setMessage(''), 5000);
            clearSelection();

        } catch (error) {
            console.error('Error in mass email sending:', error);
            setMessage('❌ Het versturen van emails is mislukt');
            setTimeout(() => setMessage(''), 5000);
        }
    };

    const handleMassSendFactuurEnGroteBoekEmail = async () => {
        setMessage(`Bezig met versturen van ${selectedIds.size} email(s)...`);
        let successCount = 0;
        let failCount = 0;

        try {
            // Get selected home visits
            const selectedVisits = homeVisits.filter(visit => selectedIds.has(visit.ID));

            for (const visit of selectedVisits) {
                try {
                    // Get fresh token for this user
                    let userToken = 'ONBEKEND';
                    try {
                        const tokenRes = await fetch(Url + 'admin/generate-password-token/' + visit.Email, {
                            method: 'GET',
                            headers: {
                                'content-type': 'application/json',
                                'Authorization': "Bearer " + token,
                            },
                        });
                        const tokenData = await tokenRes.json();
                        if (tokenData.token) {
                            userToken = tokenData.token;
                        }
                    } catch (tokenErr) {
                        console.error(`Failed to generate token for ${visit.Email}:`, tokenErr);
                    }

                    // Generate email content for this visit
                    const emailContent = generateInvoiceAndGroteBoekEmailContent({
                        naam: visit.FirstName,
                        email: visit.Email,
                        token: userToken,
                        plaats: visit.City,
                        baseUrl: window.location.origin
                    }) as any;

            const response = await fetch(Url + 'admin/send-mail', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify({
                    sender: 'info@ridderendeprins.nl',
                    recipient: visit.Email,
                    cc: 'info@ridderendeprins.nl',
                    subject: `Huisbezoek fam. ${visit.LastName} - factuur en Grote Boek`,
                    htmlBody: emailContent.html
                })
            });

                    if (response.ok) {
                        successCount++;
                    } else {
                        failCount++;
                        console.error(`Failed to send email to ${visit.Email}`);
                    }
                } catch (error) {
                    failCount++;
                    console.error(`Error sending email to ${visit.Email}:`, error);
                }
            }

            // Show result message
            if (failCount === 0) {
                setMessage(`✓ Alle ${successCount} email(s) succesvol verzonden!`);
            } else {
                setMessage(`⚠ ${successCount} email(s) verzonden, ${failCount} mislukt`);
            }

            // Clear message after 5 seconds
            setTimeout(() => setMessage(''), 5000);
            clearSelection();

        } catch (error) {
            console.error('Error in mass email sending:', error);
            setMessage('❌ Het versturen van emails is mislukt');
            setTimeout(() => setMessage(''), 5000);
        }
    };

    const getColumns = () => [
        {
            id: "select",
            Header: () => (
                <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={toggleSelectAll}
                />
            ),
            accessor: (d: any) => (
                <input
                    type="checkbox"
                    checked={selectedIds.has(d.ID)}
                    onChange={() => toggleSelect(d.ID)}
                    onClick={(e) => e.stopPropagation()}
                />
            ),
            disableSortBy: true,
        },
        {
            Header: "ID",
            accessor: "ID",
        },
        {
            Header: "Naam",
            accessor: "ContactName",
        },
        {
            Header: "Datum",
            accessor: "Date",
        },
        {
            Header: "Soort",
            accessor: "HomeVisitCategoryName",
        },
        {
            Header: "Start tijd",
            accessor: "StartTime",
        },
        {
            Header: "Plaats",
            accessor: "City",
        },
        {
            Header: "Team",
            accessor: "Team",
        },
        {
            Header: () => <FaUsers />,
            accessor: "NumberOfChildren",
        },
        {
            id: "Planned",
            Header: () => <FaClock />,
            accessor: "Planned",
            Cell: ({ value }: any) => value ? <FaCheck className="text-green-600" /> : <ImCross className="text-red-600 text-xs" />,
            sortType: (rowA: any, rowB: any) => {
                const a = rowA.values.Planned;
                const b = rowB.values.Planned;
                if (a === b) return 0;
                return a ? -1 : 1; // true values first
            },
        },
        {
            id: "Locked",
            Header: "🔒",
            accessor: "Locked",
            Cell: ({ value }: any) => value ? <FaCheck className="text-green-600" /> : <ImCross className="text-red-600 text-xs" />,
            sortType: (rowA: any, rowB: any) => {
                const a = rowA.values.Locked;
                const b = rowB.values.Locked;
                if (a === b) return 0;
                return a ? -1 : 1; // true values first
            },
        },
        {
            id: "Payed",
            Header: "€",
            accessor: "Payed",
            Cell: ({ value }: any) => value ? <FaCheck className="text-green-600" /> : <ImCross className="text-red-600 text-xs" />,
            sortType: (rowA: any, rowB: any) => {
                const a = rowA.values.Payed;
                const b = rowB.values.Payed;
                if (a === b) return 0;
                return a ? -1 : 1; // true values first
            },
        },
        {
            Header: "",
            id: "actions",
            Cell: ({row}: any) => (
                <div className="flex gap-2 items-center">
                    <button
                        onClick={(e) => {
                            e.stopPropagation();
                            handleShow(row.original);
                        }}
                        className="p-2 hover:bg-blue-100 rounded-full transition-colors"
                        title="Bekijken"
                    >
                        <FaEye className="text-blue-600" size={18} />
                    </button>
                </div>
            ),
        },


    ];
    const handleDownloadPDF = () => {
        fetch(Url + "admin/home-visits-export-pdf", {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.download =  "HomeVisitExport.pdf";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Error fetching the file:", error);
            });
    };
    const handleDownloadExcel = () => {
        fetch(Url + "admin/home-visits-export-excel", {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.download =  "HomeVisitExport.xlsx";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Error fetching the file:", error);
            });
    };

    const handleDownloadTeamPdf = () => {
        if (selectedTeam === "0") {
            console.log("No team selected");
            return;
        }

        fetch(Url + `admin/home-visits-export-pdf?team=${encodeURIComponent(selectedTeam)}`, {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'Authorization': "Bearer " + token,
            },
        })
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = url;
                link.download = `HomeVisitExport_${selectedTeam}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Error fetching the file:", error);
            });
    };

    useEffect(() => {
        if (token) {
            try{
                setLoading(true)
                fetch(Url + 'admin/home-visits', {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': "Bearer " + token,
                    },
                })
                    .then((res) => {
                        if (res.status === 200) {
                            setDataAvailable(true)
                            setAuthorized(true)
                            return res.json()
                        }else{
                            if (res.status === 401){
                                setAuthorized(false)
                            }else{
                                setAuthorized(true)
                            }
                            setDataAvailable(false)
                            return [{
                                "message": "Geen Huisbezoeken"
                            }]
                        }
                    })
                    .then((data) => {
                        setHomeVisits(data)
                    })
                    .finally(() => {
                        setLoading(false)

                    })
            }catch (error){
                setDataAvailable(false)
                console.error("Laden niet gelukt.", error);
            }


        }
    }, [token, Url, openAddHomeVisitModal, refreshTrigger, openEditHomeVisitCategoryModal]);
    useEffect(() => {
        if (token) {
            try{
                setLoading(true)
                fetch(Url + 'admin/home-visit-categories', {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': "Bearer " + token,
                    },
                })
                    .then((res) => {
                        if (res.status === 200) {
                            setDataAvailableCategories(true)
                            setAuthorized(true)
                            return res.json()
                        }else{
                            if (res.status === 401){
                                setAuthorized(false)
                            }else{
                                setAuthorized(true)
                            }
                            setDataAvailable(false)
                            return [{
                                "message": "Geen Huisbezoek categorieen"
                            }]
                        }
                    })
                    .then((data) => {
                        setHomeVisitCategories(data)
                    })
                    .finally(() => {
                        setLoading(false)

                    })
            }catch (error){
                setDataAvailable(false)
                console.error("Laden niet gelukt.", error);
            }


        }
    }, [token, Url, openAddHomeVisitCategoryModal, refreshTrigger, openEditHomeVisitCategoryModal]);

    // Extract unique teams from homeVisits data
    const teamOptions = React.useMemo(() => {
        if (!homeVisits || homeVisits.length === 0) return [];
        const teams = (homeVisits || [])
            .map((visit: any) => visit.Team)
            .filter((team: any) => team && team !== "");
        const uniqueTeams = Array.from(new Set(teams)).sort();
        return uniqueTeams.map(team => ({
            ID: team,
            Name: team
        }));
    }, [homeVisits]);

    // Filter home visits by selected team
    const filteredHomeVisits = React.useMemo(() => {
        if (selectedTeam === "0") return homeVisits;
        return homeVisits.filter(visit => visit.Team === selectedTeam);
    }, [homeVisits, selectedTeam]);

    let homeCategoryInfo

    if (dataAvailableCategories){
        homeCategoryInfo = (homeVisitCategories.map(homeVisitCategory =>
            <div key={homeVisitCategory.ID} className="flex items-center gap-2 mb-2">
                <span>{homeVisitCategory.Name} - €{homeVisitCategory.SalesPrice.toFixed(2)}</span>
                <EditButton
                    onClick={() => {
                        setSelectedCategory(homeVisitCategory);
                        setOpenEditHomeVisitCategoryModal(true);
                    }}
                />
                <DeleteButton
                    confirmText={`Weet je zeker dat je de categorie "${homeVisitCategory.Name}" wilt verwijderen?`}
                    onConfirm={() => handleDeleteHomeVisitCategory(homeVisitCategory.ID)}
                />
            </div>
        ))
    }
    else{
        homeCategoryInfo = (<div> Er zijn nog huisbezoek categorieën toegevoegd. </div>)
    }
    let dataTable
    if (dataAvailable) {
        dataTable = (
            <Table tableData={filteredHomeVisits} getColumns={getColumns()} storageKey="homeVisits"></Table>
        )
    }else{
        dataTable = (
            <div>Geen bezoeken in de database of je hebt geen rechten om deze informatie te bekijken.</div>
        )
    }
    return (
        <DefaultLayout>
            <div className="mb-4">
                <NewHomeVisitCategoryModal openModal={openAddHomeVisitCategoryModal} setOpenModal={setOpenAddHomeVisitCategoryModal}/>
                <EditHomeVisitCategoryModal openModal={openEditHomeVisitCategoryModal} setOpenModal={setOpenEditHomeVisitCategoryModal} categoryInfo={selectedCategory}/>
                <NewHomeVisitModal openModal={openAddHomeVisitModal} setOpenModal={setOpenAddHomeVisitModal} HomeVisitsCategories={homeVisitCategories} />
            </div>

            <BoxLayout>
                {loading ? (
                    <div>Loading...</div>

                ) : (
                    <div className="flex flex-col overflow-auto py-4 sm:py-0">
                        {/* Actions Section */}
                        {authorized && (
                            <div className="mb-6">
                                <H2Header headerText="Acties"/>
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
                                    <div>
                                        <DefaultButton 
                                            content="Nieuw categorie" 
                                            onClick={() => setOpenAddHomeVisitCategoryModal(true)} 
                                            disabled={false}
                                        />
                                    </div>
                                    <div>
                                        <DefaultButton 
                                            content="Nieuw bezoek" 
                                            onClick={() => setOpenAddHomeVisitModal(true)} 
                                            disabled={false}
                                        />
                                    </div>
                                    <div>
                                        <DefaultButton 
                                            content="Export PDF" 
                                            onClick={handleDownloadPDF} 
                                            disabled={false}
                                        />
                                    </div>
                                    <div>
                                        <DefaultButton 
                                            content="Export Excel" 
                                            onClick={handleDownloadExcel} 
                                            disabled={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Team Export Section */}
                        {authorized && teamOptions.length > 0 && (
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-4">
                            <div className="">
                                <SelectInput
                                    labelName="Exporteer een team:"
                                    inputName="teamFilter"
                                    value={selectedTeam}
                                    onChange={(e) => setSelectedTeam(e.target.value)}
                                    options={teamOptions}
                                    errorMessage=""
                                />
                                {selectedTeam !== "0" && (
                                    <div className="mt-3">
                                        <DefaultButton
                                            content={`Export ${selectedTeam}`}
                                            onClick={handleDownloadTeamPdf}
                                            disabled={false}
                                        />
                                    </div>
                                )}
                            </div>
                            </div>
                        )}

                        <H2Header headerText="Huisbezoek categorieën"/>
                        {homeCategoryInfo}
                        <H2Header headerText="Huisbezoeken"/>


                        {/* Mass action controls */}
                        {authorized && (
                            <div className="my-4 flex flex-wrap items-center gap-3">
                                <div className="mt-2">
                                    <SelectInput
                                        labelName=""
                                        inputName="massAction"
                                        value={selectedAction}
                                        onChange={(e) => setSelectedAction(e.target.value)}
                                        options={[
                                            { ID: "lock", Name: "Lock" },
                                            { ID: "unlock", Name: "Unlock" },
                                            { ID: "markPaid", Name: "Markeer als betaald" },
                                            { ID: "markUnpaid", Name: "Markeer als onbetaald" },
                                            { ID: "markPlanned", Name: "Tijdstip bevestigd" },
                                            { ID: "markUnplanned", Name: "Tijdstip niet bevestigd" },
                                            { ID: "sendFactuurEnGroteBoek", Name: "Verstuur factuur en grote boek mail" },
                                            { ID: "sendLaatsteInfo", Name: "Verstuur laatste informatie mail" }

                                        ]}
                                        errorMessage=""
                                    />
                                </div>
                                <DefaultButton
                                    content="Uitvoeren"
                                    onClick={handleApplyMassAction}
                                    disabled={!selectedAction || selectedIds.size === 0}
                                />
                                <DefaultButton
                                    content={`Wis selectie (${selectedIds.size})`}
                                    onClick={clearSelection}
                                    disabled={selectedIds.size === 0}
                                />
                                <DefaultButton
                                    content={selectAll ? "Deselecteer alles" : "Selecteer alles"}
                                    onClick={toggleSelectAll}
                                    disabled={!homeVisits.length}
                                />

                            </div>
                        )}
                        
                        {/* Status message for mass email sending */}
                        {message && (
                            <div className={`my-4 p-3 rounded ${
                                message.includes('mislukt') || message.includes('❌') 
                                    ? 'bg-red-100 text-red-700' 
                                    : message.includes('⚠') 
                                        ? 'bg-yellow-100 text-yellow-700'
                                        : 'bg-green-100 text-green-700'
                            }`}>
                                {message}
                            </div>
                        )}
                        
                        {dataTable}
                    </div>
                )}
            </BoxLayout>
        </DefaultLayout>
    )
}
export default AdminHomeVisitsPage